export const AlternativaEnum = {
    DOACAO: {
        id: 'DOACAO',
        nome: 'Doação ao poder público de área localizada no interior de UC de...'
    },
    ARRENDAMENTO_AREA: {
        id: 'ARRENDAMENTO_AREA',
        nome: 'Arrendamento de área sob regime de servidão ambiental ou RL...'
    },
    CADASTRAMENTO: {
        id: 'CADASTRAMENTO',
        nome: 'Cadastramento de outra área equivalente a excedente à RL em imóvel da mesma...'
    }
};
